/**
 * API `translations` ko·en·ar·id·mn — 폼은 **현재 앱 UI 언어**에 맞는 슬롯만 직접 편집(드롭다운 없음).
 * UI 공식 언어가 API 슬롯에 없으면 en 슬롯을 사용한다.
 */
import { resolveSupportedLocale } from '@/lib/i18nLocale';

export const TRIPLE_LOCALE_LABEL: Record<'ko' | 'en' | 'ar' | 'id' | 'mn', string> = {
	ko: '한국어 (ko)',
	en: 'English (en)',
	ar: 'العربية (ar)',
	id: 'Bahasa Indonesia (id)',
	mn: 'Монгол (mn)',
};

export const TRIPLE_LOCALE_CODES = ['ko', 'en', 'ar', 'id', 'mn'] as const;
export type TripleLocaleCode = (typeof TRIPLE_LOCALE_CODES)[number];

/** `i18n.language`(= 브라우저/저장 반영) → translations 슬롯. API 슬롯 외 언어는 en. */
export function resolveTripleLocaleForEntityForm(i18nLanguage: string | undefined): TripleLocaleCode {
	const r = resolveSupportedLocale(i18nLanguage);
	if (r === 'ko' || r === 'en' || r === 'ar' || r === 'id' || r === 'mn') return r;
	return 'en';
}
